var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
window._WS_COMPONENTS_PACKAGE_TARGET = 'vue2';
// eslint-disable-next-line max-lines-per-function
export var generateProxy = function (app, name, component, uiRender) {
    app.component(name, component);
    // eslint-disable-next-line vue/one-component-per-file
    return {
        name: "".concat(name, "Proxy"),
        inheritAttrs: false,
        data: function () {
            return {
                cmp_id: '',
                cmp_vm: null,
                requestedSlots: {}
            };
        },
        watch: {
            '$attrs': {
                deep: true,
                handler: function () {
                    // @ts-ignore
                    uiRender.update(this.cmp_id, formatAttrs(this.$listeners, this.$attrs, this === null || this === void 0 ? void 0 : this.$vnode));
                }
            },
            '$listeners': {
                deep: true,
                handler: function () {
                    // @ts-ignore
                    uiRender.update(this.cmp_id, formatAttrs(this.$listeners, this.$attrs, this === null || this === void 0 ? void 0 : this.$vnode));
                }
            }
        },
        props: {
            dontUnmount: {
                type: Boolean,
                "default": false
            }
        },
        mounted: function () {
            var _this = this;
            // @ts-ignore
            var attrs = formatAttrs(this.$listeners, this.$attrs, this.$vnode);
            var options = {
                name: name,
                attrs: attrs,
                requestSlot: function (name) {
                    // @ts-ignore
                    if (!_this.$slots[name] && !_this.$scopedSlots[name]) {
                        return false;
                    }
                    return function (slotConfig) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: 
                                // @ts-ignore
                                return [4 /*yield*/, this.$nextTick()];
                                case 1:
                                    // @ts-ignore
                                    _a.sent();
                                    // @ts-ignore
                                    if (this.requestedSlots[slotConfig.name]) {
                                        // @ts-ignore
                                        this.requestedSlots[slotConfig.name].container.$forceUpdate();
                                    }
                                    // @ts-ignore
                                    slotConfig.container = new PortalOutlet({
                                        el: slotConfig.getAnchor(),
                                        parent: this,
                                        propsData: { slotConfig: slotConfig }
                                    });
                                    // @ts-ignore
                                    this.$set(this.requestedSlots, slotConfig.name, slotConfig);
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                },
                // @ts-ignore
                getContainer: function () { return _this.$el.parentNode; },
                // @ts-ignore
                getAnchor: function () { return _this.$el; },
                // @ts-ignore
                slots: Object.keys(__assign(__assign({}, this.$slots), this.$scopedSlots)),
                // @ts-ignore
                component: component
            };
            // @ts-ignore
            var _a = uiRender.mountComponent(options), id = _a.id, vm = _a.vm;
            this.cmp_id = id;
            this.cmp_vm = vm;
        },
        beforeDestroy: function () {
            if (this.dontUnmount) {
                return;
            }
            // @ts-ignore
            uiRender.unMountComponent(this.cmp_id);
            // @ts-ignore
            var keys = Object.keys(this.requestedSlots);
            for (var i = 0; i < keys.length; i++) {
                // @ts-ignore
                this.requestedSlots[keys[i]].container.$destroy();
            }
            // @ts-ignore
        },
        // @ts-ignore
        render: function (h) {
            // @ts-ignore
            var keys = Object.keys(this.requestedSlots);
            for (var i = 0; i < keys.length; i++) {
                // @ts-ignore
                this.requestedSlots[keys[i]].container.$forceUpdate();
            }
            this.$refs = this.proxyRefs;
            return h('span', { attrs: { style: 'display: none' } }, []);
        }
    };
};
// eslint-disable-next-line sonarjs/cognitive-complexity
function formatAttrs($listeners, $attrs, $vnode) {
    var _a, _b, _c, _d;
    var attrs = {};
    var keys = Object.keys($listeners);
    for (var i = 0; i < keys.length; i++) {
        var oldKey = keys[i];
        var newKey = keys[i];
        if (keys[i] === 'input') {
            newKey = 'onUpdate:model-value';
        }
        else {
            newKey = 'on' + newKey.charAt(0).toUpperCase() + newKey.slice(1);
        }
        attrs[newKey] = $listeners[oldKey];
    }
    keys = Object.keys($attrs);
    for (var i = 0; i < keys.length; i++) {
        var newKey = keys[i];
        if (keys[i] === 'value') {
            newKey = 'model-value';
        }
        attrs[newKey] = $attrs[keys[i]];
    }
    var classNames = ((_a = $vnode === null || $vnode === void 0 ? void 0 : $vnode.data) === null || _a === void 0 ? void 0 : _a["class"]) ? Object.keys($vnode.data["class"]) : [];
    var dynamicClasses = classNames.reduce(function (acc, className) { return acc += $vnode.data["class"][className] ? ' ' + className : ''; }, '');
    var staticClasses = (_c = (_b = $vnode === null || $vnode === void 0 ? void 0 : $vnode.data) === null || _b === void 0 ? void 0 : _b.staticClass) !== null && _c !== void 0 ? _c : '';
    attrs['class'] = [dynamicClasses, staticClasses].join(' ').trim() || undefined;
    attrs['style'] = ((_d = $vnode === null || $vnode === void 0 ? void 0 : $vnode.data) === null || _d === void 0 ? void 0 : _d.staticStyle) || undefined;
    return attrs;
}
export var PortalOutlet = {};
export var setupPortalOutlet = function (Vue) {
    // eslint-disable-next-line vue/one-component-per-file
    PortalOutlet = Vue.extend({
        // as an abstract component, it doesn't appear in
        // the $parent chain of components.
        // which means the next parent of any component rendered inside of this oen
        // will be the parent from which is was sent
        abstract: true,
        name: 'PortalOutlet',
        props: {
            slotConfig: {
                type: Object,
                "default": function () { return ({}); }
            }
        },
        render: function () {
            return this.$parent._self._t(this.slotConfig.name, null, this.slotConfig.attrs)[0];
        }
    });
};
